import { render } from "./MainFilter.vue?vue&type=template&id=b8e57440&bindings={\"config\":\"setup\",\"filter\":\"setup\",\"channelCountries\":\"setup\",\"toggleLanguageFilter\":\"setup\"}"
import script from "./MainFilter.vue?vue&type=script&lang=js"
export * from "./MainFilter.vue?vue&type=script&lang=js"
script.render = render

export default script